import { render, staticRenderFns } from "./AnnotationOverlayMask.vue?vue&type=template&id=5e547b33&"
import script from "./AnnotationOverlayMask.vue?vue&type=script&lang=js&"
export * from "./AnnotationOverlayMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports